import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { d as close } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';
import { P as Pill } from '../Pill/Pill-CD9LP8HX.js';
import { I as IconButton } from '../Button/IconButton/IconButton-q1IFiTAg.js';
import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';
import { g as getFocusableElements } from '../LocalModules/storm-ui-utils/dist/esm/focusableElements/getFocusableElements-BjFtn5aB-BjFtn5aB.js';

const PillBoxWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40021409__sc-1o2y8n-0"
})(["display:flex;padding:", ";border:", ";border-block-start:none;border-radius:0 0 ", " ", ";background-color:", ";overflow:auto;", ""], ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.border.medium.default, ({
  theme
}) => theme.border.radius.small, ({
  theme
}) => theme.border.radius.small, ({
  theme
}) => theme.surface.default, isMobile(css(["padding:", ";"], ({
  theme
}) => theme.spacing.xsmall.mobile)));
const InnerPillWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40021409__sc-1o2y8n-1"
})(["display:flex;flex-grow:1;flex-wrap:wrap;gap:", ";", ""], ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["gap:", ";"], ({
  theme
}) => theme.spacing.xsmall.mobile)));
const RemoveAllButtonWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40021409__sc-1o2y8n-2"
})(["display:flex;align-items:flex-start;justify-content:flex-end;"]);
const RemoveAllButton = /*#__PURE__*/styled(IconButton).withConfig({
  componentId: "sc-storm-ui-40021409__sc-1o2y8n-3"
})([""]);
const renderPill = ([key, pillProps]) => /*#__PURE__*/React__default.createElement(Pill, _extends({}, pillProps, {
  key: key,
  applied: true,
  size: "small"
}));
const PillBox = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  const {
    pills = [],
    removeAllLabel,
    onRemovePill,
    onRemoveAll,
    ...rest
  } = props;
  const handleKeyDown = event => {
    const currentPill = event.currentTarget;
    if (event.key === KEYBOARD_KEYNAMES.ARROW_RIGHT || event.key === KEYBOARD_KEYNAMES.ARROW_DOWN) {
      var _nextFocusableElement;
      let current = currentPill;
      let nextFocusableElement;
      while (current && !nextFocusableElement) {
        var _current, _current2;
        // if there is no next, wrap to the first
        current = ((_current = current) === null || _current === void 0 ? void 0 : _current.nextElementSibling) || ((_current2 = current) === null || _current2 === void 0 || (_current2 = _current2.parentNode) === null || _current2 === void 0 ? void 0 : _current2.firstElementChild) || null;
        [nextFocusableElement] = getFocusableElements(current);
      }
      (_nextFocusableElement = nextFocusableElement) === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
    }
    if (event.key === KEYBOARD_KEYNAMES.ARROW_LEFT || event.key === KEYBOARD_KEYNAMES.ARROW_UP) {
      var _prevFocusableElement;
      let current = currentPill;
      let prevFocusableElement;
      while (current && !prevFocusableElement) {
        var _current3, _current4;
        // if there is no prev, wrap to the last
        current = ((_current3 = current) === null || _current3 === void 0 ? void 0 : _current3.previousElementSibling) || ((_current4 = current) === null || _current4 === void 0 || (_current4 = _current4.parentNode) === null || _current4 === void 0 ? void 0 : _current4.lastElementChild) || null;
        [prevFocusableElement] = getFocusableElements(current);
      }
      (_prevFocusableElement = prevFocusableElement) === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
    }
  };
  return /*#__PURE__*/React__default.createElement(PillBoxWrapper, _extends({}, rest, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement(InnerPillWrapper, null, pills === null || pills === void 0 ? void 0 : pills.map(pill => {
    const [key, pillProps] = pill;
    return renderPill([key, {
      ...pillProps,
      onKeyDown: handleKeyDown,
      key,
      onClose: event => onRemovePill === null || onRemovePill === void 0 ? void 0 : onRemovePill(event, pill),
      size: 'small',
      closeLabel: `remove ${pillProps.label}`
    }]);
  })), /*#__PURE__*/React__default.createElement(RemoveAllButtonWrapper, null, pills && pills.length > 0 && /*#__PURE__*/React__default.createElement(RemoveAllButton, {
    icon: close,
    label: removeAllLabel,
    onClick: onRemoveAll,
    variant: "transparent",
    small: true
  })));
});

export { PillBox as P };
//# sourceMappingURL=PillBox-CKXVjSKB.js.map
